<template>
  <button class="BackButton" aria-label="Back" v-html="backSvg"></button>
</template>

<script setup>
import backSvg from './images/back.svg?raw'
</script>
